import { useEffect, useState } from "react";
import Scene from "@/components/world/Scene";
import HUD from "@/components/world/HUD";
import SectionPanel from "@/components/world/SectionPanel";
import Loader from "@/components/world/Loader";
import { useWorldStore } from "@/components/world/store";
import SEO from "@/components/SEO";

export default function World() {
  const [booting, setBooting] = useState(true);
  const closePanel = useWorldStore((s) => s.closePanel);
  const openId = useWorldStore((s) => s.openId);
  const resetInput = useWorldStore((s) => s.resetInput);

  // ESC closes panel
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape" && openId) {
        resetInput();
        closePanel();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [openId, closePanel, resetInput]);

  // Reset input state whenever panel opens (prevents stuck keys)
  useEffect(() => {
    if (openId) resetInput();
  }, [openId, resetInput]);

  return (
    <div className="relative w-screen h-screen overflow-hidden bg-[#050307] text-[#F4EADE]" data-testid="world-page">
      <SEO
        title="You ask, we develop — Explore in 3D"
        description="Fly, dive and orbit through our immersive 3D landing to discover Greinch WW LLC B2B software development, e-commerce integrations and global brokerage services."
        path="/"
      />
      {/* Scene */}
      <div className="absolute inset-0">
        <Scene />
      </div>
      {/* HUD overlay */}
      <HUD />
      {/* Section panels */}
      <SectionPanel />
      {/* Boot loader */}
      {booting && <Loader onDone={() => setBooting(false)} />}
    </div>
  );
}
